import { useRef } from "react"
import styled from "@emotion/styled"

import useParallax from "hooks/useParallax"

import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"

import Image from "components/media/ImageCLD"
import Video from "components/media/VideoCLD"
import BlockText from "components/push/BlockText"
import { Container, FrameDyn } from "components/push/commons"

const Root = styled.aside`
  cursor: pointer;
  position: relative;
  --frame-border-width: 20px;
  --frame-border-color: white;

  ${getMediaQuery("m", { max: true })} {
    --frame-border-width: 10px;
  }

  * {
    pointer-events: none;
  }

  a,
  button {
    pointer-events: auto;
  }

  ${({ marie_louise_biggie }) => marie_louise_biggie && fullGrid}
`

const MarieLouiseBiggie = styled.div`
  grid-column: main;
  margin-block: var(--outer-margin);

  > div {
    width: auto;
  }
`

const hasMediaSources = media => Boolean(media?.sources_localized?.length || media?.sources?.length)
const getPosterMedia = (poster, mediaKey) => poster?.find(item => hasMediaSources(item?.[mediaKey]))?.[mediaKey]
const getMediaProps = (media, poster, mediaKey) => (hasMediaSources(media) ? media : getPosterMedia(poster, mediaKey))

export default function Push(props) {
  const {
    className,
    link,
    heading,
    chapo,
    paragraph,
    image_cld,
    video_cld,
    poster,
    text_width,
    marie_louise,
    marie_louise_biggie,
    parallax,
    title,
    aria_label,
    ...rest
  } = props

  const ariaLabel = aria_label || heading.title || undefined

  const videoProps = getMediaProps(video_cld, poster, "video_cld")
  const imageProps = getMediaProps(image_cld, poster, "image_cld")

  const ref = useRef()

  const y = useParallax(ref)

  function onClick(e) {
    if (e.target.closest("a, button")) return
    const linkEl = e.currentTarget.querySelector("a[href]")
    linkEl?.click()
  }

  const media = videoProps ? <Video autoPlay noButton {...videoProps} sizes='100vw' /> : imageProps ? <Image {...imageProps} sizes='100vw' /> : null

  const content = (
    <Container style={{ "--ypos": parallax ? y : null, "--scale": parallax ? "1.2" : "1" }}>
      <BlockText isPush heading={heading} chapo={chapo} paragraph={paragraph} link={link} text_width={text_width} />
      {media && <figure>{media}</figure>}
    </Container>
  )

  return (
    <Root className={className} onClick={onClick} ref={ref} marie_louise_biggie={marie_louise_biggie} aria-label={ariaLabel} {...rest}>
      {marie_louise_biggie ? <MarieLouiseBiggie>{content}</MarieLouiseBiggie> : content}
      {marie_louise && !marie_louise_biggie && <FrameDyn />}
    </Root>
  )
}
